module.exports = __webpack_public_path__ + "svg_80x80/logback.94c40e.svg";